<div class="forgot-password-container">
    <div class="card otp-card">
        <div class="card-body">
            <div class="col-md-6 col-lg-5 d-none d-md-block triangle text-center">
                <img src="../../../../assets/logo/EMP.png" alt="login form" class="img-fluid logo" />
            </div>
            <h2 class="form-title text-center">Vendor OTP Verification</h2>
            <p class="text-center" *ngIf="mailId">Email: {{ mailId }}</p>
            <p class="text-center" *ngIf="!mailId" style="color: red;">Mail ID not received!</p>

            <form [formGroup]="otpForm" (ngSubmit)="onSubmit()">
                <div class="otp-input-container text-center">
                    <input #otpInput class="otp-input" type="text" formControlName="digit0" maxlength="1"
                        (input)="moveCursor(0, $event)" />
                    <input #otpInput class="otp-input" type="text" formControlName="digit1" maxlength="1"
                        (input)="moveCursor(1, $event)" />
                    <input #otpInput class="otp-input" type="text" formControlName="digit2" maxlength="1"
                        (input)="moveCursor(2, $event)" />
                    <input #otpInput class="otp-input" type="text" formControlName="digit3" maxlength="1"
                        (input)="moveCursor(3, $event)" />
                    <input #otpInput class="otp-input" type="text" formControlName="digit4" maxlength="1"
                        (input)="moveCursor(4, $event)" />
                    <input #otpInput class="otp-input" type="text" formControlName="digit5" maxlength="1"
                        (input)="moveCursor(5, $event)" />
                </div>

                <p class="otp-instruction py-2 text-center">
                    <small>Enter the 6-digit OTP sent to your email</small>
                </p>

                <p *ngIf="errorMessage" class="error-message text-center">{{ errorMessage }}</p>

                <div class="text-center">
                    <button type="submit" class="btn btn-primary" [disabled]="otpForm.invalid || isVerifying">
                        {{ isVerifying ? 'Verifying...' : 'Verify OTP' }}
                    </button>

                    <div class="resend-otp-container mt-3">
                        <span *ngIf="countdown <= 0">
                            <a href="javascript:void(0);" (click)="resendOtp()">Resend OTP</a>
                        </span>
                        <span *ngIf="countdown > 0" class="text-muted">
                            Resend OTP in {{ countdown }} seconds
                        </span>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>